<template>
  <div class="cp-footer">
    <div class="content">
      <div class="logo" />
      <p>
        <a target="_blank" href="http://www.ga-me.com/cn/about_us.php">关于巨人</a><span>|</span>
        <a target="_blank" href="http://www.ztgame.com/html/clause.html">服务条款</a><span>|</span>
        <a target="_blank" href="http://www.ztgame.com/swhz.html">商务中心</a><span>|</span>
        <a target="_blank" href="http://www.ga-me.com/cn/contact_details.php">联系我们</a><span>|</span>
        游戏客服（021-61205656）<span class="space">上海巨人网络科技有限公司 版权所有</span><br>
        健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。<br>
        网络文化经营许可证：沪网文（2017）8450-629号<span class="space">增值电信业务：沪B2-20050107;互联网出版：新出网证(沪)字008号;文网游备字〔 2016 〕Ｃ -RPG 0521号 ISBN号： 978-7-7979-2765-9</span><br>
      </p>
      <a href="http://sh.cyberpolice.cn/infoCategoryListAction.do?act=initjpg" target="_blank" class="icon wj" />
      <a class="icon zx" />
      <a href="http://www.shjbzx.cn/" target="_blank" class="icon wf" />
      <a href="http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020170703190538000001896554-SAIC_SHOW_310000-20171108192223631725&amp;signData=MEUCIQDQnAyL5DFlHdA/KX8XR/MMqfZIysPfbnQOCtTQYIV2tQIgWDLdelQgucUz/pTfount98xrUv5R7SOYZlc3rq8ImRE" target="_blank" class="icon lz" />
      <p class="sl">
        <span>|</span>适龄提示：本游戏适合18岁以上的玩家进入
        <span class="space">
          <a href="http://jrkf.ztgame.com/index.php?g=front&amp;m=index&amp;a=article&amp;aid=5365&amp;term_name=%E5%BF%AB%E6%8D%B7%E6%9C%8D%E5%8A%A1" target="_blank">家长监护工程 &gt;</a>
        </span><br>
      </p>
    </div>
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
    .cp-footer
        width: 100%;
        height: 154px;
        background #1d2734;
        // position: absolute;
        // bottom: 0;
        .content
            width: 1056px;
            height: 154px;
            font-size: 12px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            .logo
                background: url("./images/foot.png") no-repeat;
                background-position top right;
                background-size 130px 47px;
                position: absolute;
                top: 30px;
                width: 197px;
                height: 54px;
            p
                padding-top: 18px;
                padding-left: 220px;
                color: #a3a3a3;
                line-height: 22px;
                a
                    color: #a3a3a3;
                    &:hover
                        color: #89aeca;
                        text-decoration: underline;
            span
                width: 17px;
                text-align: center;
                display: inline-block;
            .space
                margin-left: 15px;
                width: auto;
            .icon
                display: block;
                width: 28px;
                height: 28px;
                background: url("./images/footer_wj.png") no-repeat;
                float: left;
            .wj
                margin-left: 220px;
                background-position: 0 0;
            .zx
                margin-left: 5px;
                background-position: -33px 0;
            .wf
                margin-left: 5px;
                background-position: -66px 0;
            .lz
                margin-left: 11px;
                background-position: -105px 0;
            .dz
                margin-left: 5px;
                background-position: -138px 0;
            .sl
                margin-top: -16px;
                margin-left: 135px;
</style>
<script>
export default {
  beforeMount() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
